export function AppHeader(){
return(<div className="App-header">
          <h2>Smash Ultimate</h2>
          <div className="punishCalculator">
            <h1>Punish</h1>
            <h1>Calculator</h1>
          </div>
          <h4>v0.0.2</h4>
        </div>);}